import { MEDIA_SIZE_MEDIUM } from '@/media/constants/sizeCodes';
import { ProductType } from '@/product/constants/productTypes';
import { VIEW_TYPE_GRID } from '@/product/constants/viewType';

import { viewTemplateRepository } from '../repository/ViewTemplateRepository';

export function getDefaultCollectionSettings(productType: ProductType) {
  return {
    type: VIEW_TYPE_GRID,
    mediaSize: MEDIA_SIZE_MEDIUM,
    viewTemplate: viewTemplateRepository.getDefaultViewTemplateId(productType),
    isAutoplayEnabled: true,
  };
}
